import { render, staticRenderFns } from "./CustomFeeder.vue?vue&type=template&id=3934794c"
import script from "./CustomFeeder.vue?vue&type=script&lang=ts"
export * from "./CustomFeeder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports